import { memo } from "react";

import { Typography } from "neetoui";

import PercentageBar from "./PercentageBar";

const MetaInfoItem = ({ name, value }) => (
  <>
    <Typography style="body2" textTransform="capitalize">
      {name}
    </Typography>
    <div className="col-span-3 flex items-center gap-2">
      <PercentageBar {...{ value }} />
    </div>
  </>
);

export default memo(MetaInfoItem);
